export default __webpack_public_path__ + "static/media/dark-theme-elevation.d87d090f.png";